import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Formsy from 'formsy-react';
import _ from 'lodash';
import React from 'react';

import MinimalTextArea from '@sophocles/components/FormFields/MinimalTextArea';
import MinimalTextBox from '@sophocles/components/FormFields/MinimalTextBox';

class FirmwareDialog extends React.Component {
  constructor(props) {
    super(props);
    const { firmware } = props;
    this.state = {
      obsolete: firmware ? firmware.get('obsolete', false) : false,
      testing: firmware ? firmware.get('in_testing', true) : true,
      upgradeFile: null,
      canSubmit: true,
    };
  }

  _toggleObsolete = () => this.setState({ obsolete: !this.state.obsolete });

  _toggleInTesting = () => this.setState({ testing: !this.state.testing });

  handleClose = () => this.props.closeDialog();

  save = values => {
    const { save, firmware } = this.props;
    const id = firmware ? firmware.get('id', 0) : 0;

    const fd = new FormData();

    fd.append('obsolete', this.state.obsolete);
    fd.append('in_testing', this.state.testing);
    fd.append('release_notes', values.release_notes);
    if (_.has(values, 'version')) {
      fd.append('version', values.version);
    }
    if (this.state.upgradeFile) {
      fd.append('upgrade_file', this.state.upgradeFile);
    }
    return save(id, fd);
  };

  submitForm = () => this.form.submit();

  saveUpgradeFile = event => {
    const { files } = event.target;
    const upgradeFile = files[0];
    this.setState({ upgradeFile: upgradeFile });
  };

  enableSaveButton = () => this.setState({ canSubmit: true });

  disableSaveButton = () => this.setState({ canSubmit: false });

  render() {
    const { open, firmware, edit, errors, clearErrors } = this.props;
    const { canSubmit, obsolete, upgradeFile, testing } = this.state;

    const hasUpgradeFile = firmware ? firmware.get('upgrade_file', false) : false;

    const upgradeFileName = hasUpgradeFile ? hasUpgradeFile.split('/').slice(-1)[0] : null;

    const actions = [
      <Button key="cancel" variant="outlined" onClick={this.handleClose}>
        Cancel
      </Button>,
      <Button key="submit" variant="contained" disabled={!canSubmit} onClick={this.submitForm}>
        Submit
      </Button>,
    ];

    const dialogTitle = (edit ? 'Edit' : 'Add') + ' Firmware Dialog';

    return (
      <Dialog open={open} onClose={this.handleClose}>
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent dividers>
          <Formsy
            ref={input => (this.form = input)}
            onSubmit={this.save}
            onValid={this.enableSaveButton}
            onInvalid={this.disableSaveButton}
          >
            <div style={{ fontSize: '14px' }}>
              {edit ? (
                <div>
                  <div>
                    <b>Version:</b> {firmware.get('version')}{' '}
                  </div>
                </div>
              ) : (
                <div>
                  <label style={{ margin: 0, fontWeight: 'bold' }}>Version</label>
                  <MinimalTextBox
                    name="version"
                    value={''}
                    error={_.get(errors, 'version', false)}
                    passValue={clearErrors}
                    validations={{
                      valueRequired: (values, value) =>
                        /^[0-9]+[\\.][0-9]+[\\.][0-9]+$/.test(value) ? true : 'Must be in format X.Y.Z', // You can return an error
                    }}
                  />
                </div>
              )}
              <div>
                <label style={{ margin: 0, fontWeight: 'bold' }}>Release Notes</label>
                <MinimalTextArea
                  name="release_notes"
                  value={firmware ? firmware.get('release_notes', '') : ''}
                  inputProps={{ rows: 4 }}
                />
              </div>
              <div>
                <label>
                  <input type="checkbox" checked={testing} onChange={this._toggleInTesting} /> In Testing
                </label>

                <label style={{ marginLeft: '10px' }}>
                  <input type="checkbox" checked={obsolete} onChange={this._toggleObsolete} /> Obsolete Version
                </label>
              </div>
              <div>
                <b>Upgrade file:</b>
              </div>
              <div>{!upgradeFile && !!upgradeFileName && <span>{upgradeFileName}</span>}</div>
              <div>
                <input style={{ width: '100%' }} type="file" onChange={this.saveUpgradeFile} />
              </div>
            </div>
          </Formsy>
        </DialogContent>
        <DialogActions>{actions}</DialogActions>
      </Dialog>
    );
  }
}

export default FirmwareDialog;
